import type { CSSProperties, MouseEvent, ReactNode } from 'react'

interface LinkProps {
  to: string
  children: ReactNode
  className?: string
  style?: CSSProperties
  onClick?: (e: MouseEvent) => void
}

export const Link = ({ to, children, className, style, onClick }: LinkProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    onClick?.(e)
    window.history.pushState({}, '', to)
    window.dispatchEvent(new Event('popstate'))
  }

  return (
    <a href={to} onClick={handleClick} className={className} style={style}>
      {children}
    </a>
  )
}
